<div class="container" [ngStyle]="{ 'padding-top': showTitle ? '1em' : '0em' }">
  <h3 class="m-0" *ngIf="showTitle">{{ attributeCount.name }}</h3>
  <mat-divider *ngIf="showTitle"></mat-divider>
  <div *ngFor="let attributeValueCounts of attributeCount.counts" class="bar-container" fxLayout fxLayoutGap="1em">
    <div
      matTooltip="{{ attributeValueCounts.name }}"
      matTooltipPosition="after"
      matTooltipShowDelay="500"
      class="bar-label"
      fxFlex="20"
    >
      {{ attributeValueCounts.name }}
    </div>
    <div fxFlex="70%" fxLayout>
      <div
        class="bar"
        *ngIf="attributeValueCounts.count"
        [ngStyle]="{
          cursor: disableBarClick ? 'default' : 'pointer',
          width: attributeCount.getPercentage(attributeValueCounts) + '%',
          'min-width': attributeCount.getPercentage(attributeValueCounts) + '%'
        }"
        (click)="clickCallback(attributeValueCounts.name)"
      ></div>
      <div class="count-label">{{ attributeValueCounts.count }}</div>
    </div>
    <div fxFlex>
      <a mat-icon-button *ngIf="showSearchIcon" color="primary" (click)="searchCallback(attributeValueCounts.name)">
        <mat-icon class="md-18">search</mat-icon>
      </a>
    </div>
  </div>
</div>
